import PropTypes from "prop-types";
import React, { Fragment, useEffect, useState } from "react";
import MetaTags from "react-meta-tags";
import { Link, useHistory } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import LayoutOne from "../../layouts/LayoutOne";
import Breadcrumb from "../../wrappers/breadcrumb/Breadcrumb";
import { fetchUser, saveUser } from "../../redux/actions/userAction";
import {
  fetchProducts,
  saveProducts,
} from "../../redux/actions/productsAction";
import { connect, useDispatch } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Article, Prop } from "./animationList";
import ReactLoading from "react-loading";
import { fetchRegistrati } from "../../helpers/dbOperations";
import { Autocomplete } from "@material-ui/lab";
import { TextField } from "@material-ui/core";
import { SAVE_CART } from "../../redux/actions/cartActions";
import { SAVE_WISHLIST } from "../../redux/actions/wishlistActions";
import { useLocation } from "react-router-dom";
const LoginRegister = ({
  userData,
  setToken,
  saveUser,
  saveProducts,
  setLastLogin,
}) => {
  const prodottiSenzaLogin = true;
  const [username, setUserName] = useState(localStorage.getItem("username"));
  const [password, setPassword] = useState(localStorage.getItem("password"));
  const [inCaricamento, setinCaricamento] = useState(false);
  const [localita, setLocalita] = useState([]);
  const [sede, setSede] = useState(JSON.parse("{}"));
  const [sedeOperativa, setSedeOperativa] = useState(JSON.parse("{}"));
  const [error, setError] = useState("");
  const history = useHistory();
  const dispatch = useDispatch();
  const [sessioneScaduta, setSessioneScaduta] = useState(false);
  const timerLogin = window["configPegaso"].timerLogin;
  const [tab, setTab] = useState("");
  const location = useLocation(); // Ottiene l'oggetto location

  /*useEffect(() => {
   if(localStorage.getItem("username") && localStorage.getItem("password")){
     setUserName(localStorage.getItem("username"))
     setPassword(localStorage.getItem("password"))
     setTimeout(()=>{
      if(document.getElementById("login")) document.getElementById("login").click()
     } , 2000)
     
   }
  }, [])*/

  useEffect(async () => {
    //var endpoint = "https://dgaapi.pegasogest.it/api/" + "pegaso/getLocalita";
    const time = Date.now() - window.localStorage.getItem("lastLogin");
    if (time > timerLogin) setSessioneScaduta(true);
    const queryParams = new URLSearchParams(location.search); // Analizza la query string
    const tabParam = queryParams.get("tab") ? queryParams.get("tab") : "login"; // Ottiene il valore di "tab"
    setTab(tabParam);
  }, []);

  useEffect(() => {
    if (tab === "register") {
      console.log("caricamento località");
      var endpoint = global.endpoint + "pegaso/getLocalita";

      fetch(endpoint, {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        withCredentials: false,
      })
        .then((res) => res.json())
        .then((result) => {
          setLocalita(result.localita);
        });
    }
  }, [tab]);

  function caricaCredenzialiRegistrazione() {
    var Elemento;

    var Fields = [
      "RagSoc",
      "CodFis",
      "ParIva",
      "CodDes",
      "EMailPec",
      "IndSedLeg",
      "IndSedOpe",
      "Nom",
      "Cog",
      "EMail",
      "SitWeb",
      "Tel",
      "Cel",
    ];
    var valueFields = {};

    Fields.map((field) => {
      Elemento = document.querySelector('[nomeField="' + field + '"]');
      valueFields[field] = Elemento ? Elemento.value : "";
    });

    valueFields.Errore = "";
    valueFields.LocSedLeg = sede.Loc;
    valueFields.ProSedLeg = sede.Pro;
    valueFields.CapSedLeg = sede.CAP;

    valueFields.LocSedOpe = sedeOperativa ? sedeOperativa.Loc : "";
    valueFields.ProSedOpe = sedeOperativa ? sedeOperativa.Pro : "";
    valueFields.CapSedOpe = sedeOperativa ? sedeOperativa.CAP : "";
    return valueFields;
  }
  function controllaForm() {
    var Pec;
    var CodDes;

    var Fields = [
      "RagSoc",
      "CodFis",
      "ParIva",
      "CodDes",
      "EMailPec",
      "IndSedLeg",
      "IndSedOpe",
      "Loc",
      "Cap",
      "Pro",
      "Nom",
      "Cog",
      "EMail",
      "SitWeb",
      "Tel",
      "Cel",
    ];
    var valueFields = {};

    Pec = document.getElementById("EMailPec");
    CodDes = document.getElementById("CodDes");
    if (Pec.value === "" && CodDes.value === "") {
      Pec.style.borderColor = "red";
      CodDes.style.borderColor = "red";
      alert("Almeno uno tra PEC e Codice Destinatario deve essere inserito");
      return false;
    } else {
      Pec.style.borderColor = "#ebebeb";
      CodDes.style.borderColor = "#ebebeb";
    }
    var indSedLeg = document.getElementById("IndSedLeg");
    var locSedLeg = document.getElementById("country-select-demo-legale");
    if (indSedLeg.value === "" || sede === null) {
      indSedLeg.style.borderColor = "red";
      setError("Inserire la località");
      alert("Inserire l'indirizzo della sede legale");
      return false;
    } else {
      indSedLeg.style.borderColor = "#ebebeb";
      setError("");
    }
    valueFields.Errore = "";
    return true;
  }
  const handleRegistrati = async (e) => {
    e.preventDefault();
    if (!controllaForm()) return;
    setinCaricamento(true);
    var credenziali = caricaCredenzialiRegistrazione();
    //console.log(credenziali);
    if (credenziali.Errore != "") {
      setinCaricamento(false);
      return;
    }

    //console.log(credenziali);

    var risultatoRegistrati = await fetchRegistrati(credenziali);
    setinCaricamento(false);

    var Errore = risultatoRegistrati.Errore;

    if (Errore != "") {
      addToast(Errore, {
        appearance: "error",
        autoDismiss: true,
        placement: "bottom-left",
      });
      return;
    } else {
      history.push(process.env.PUBLIC_URL + "/");
      addToast(
        "Modulo di Registrazione Inviato... a Breve ti invieremo una mail",
        { appearance: "success", autoDismiss: true, placement: "bottom-left" }
      );
    }
  };

  const handleSubmit = async (e) => {
    let passwordErrata = false;

    e.preventDefault();

    if (username == undefined || password == undefined) {
      if (!prodottiSenzaLogin) alert("Riempire correttamente i campi!");
      setinCaricamento(false);
      return;
    }
    setinCaricamento(true);
    localStorage.setItem("username", username);
    localStorage.setItem("password", password);

    var risultatoUser = await fetchUser({ username, password });

    saveUser(risultatoUser);
    console.log(risultatoUser);
    console.log(username);
    if (username && !risultatoUser?.user?.username) {
      addToast("Nome utente o password non valida", {
        appearance: "error",
        autoDismiss: true,
        placement: "bottom-left",
      });
      passwordErrata = true;
    } else {
      addToast("Benvenuto " + (risultatoUser?.user?.RagSoc || ""), {
        appearance: "success",
        autoDismiss: true,
        placement: "bottom-left",
      });
    }

    dispatch({
      type: SAVE_CART,
      payload: risultatoUser.user.cart /*JSON.parse(risultatoUser.user.cart) */,
    });
    dispatch({
      type: SAVE_WISHLIST,
      payload:
        risultatoUser.user.wishlist /*JSON.parse(risultatoUser.user.cart) */,
    });

    var risultatoProducts = await fetchProducts({
      username,
      password,
      recommended: risultatoUser?.user?.jsonVendite,
    });

    var Errore = risultatoProducts?.Errore;

    if (Errore && Errore != "") {
      addToast(Errore, {
        appearance: "error",
        autoDismiss: true,
        placement: "bottom-left",
      });
      return;
    } else {
      //addToast("Benvenuto " + username + " caricamento prodotti...", { appearance: "success", autoDismiss: true, placement: 'bottom-left' });
    }
    saveProducts(risultatoProducts, addToast);

    var jUser = risultatoUser?.user;
    var token = jUser.IDCli == 0 ? jUser.IDAge : jUser.IDCli;
    localStorage.setItem("IDDetCliRef", jUser.IdDetCliRef);
    sessionStorage.setItem("notShowValentine2022", true);
    sessionStorage.setItem("notShowAumentoPrezzi2022", true);
    //localStorage.setItem("notShowSpedizioni2maggio", true)
    sessionStorage.setItem("notShowDialogPromoSummer2022", true);
    sessionStorage.setItem("notShowInventario2022", true);
    sessionStorage.setItem("notShowPTE", true);
    sessionStorage.setItem("notShowPromoSanValentino", true);
    sessionStorage.setItem("notShowExpo", true);
    sessionStorage.setItem("notShowOctober4", true);
    sessionStorage.setItem("notShowNovember8", true);
    sessionStorage.setItem("notShowDecember8", true);

    setLastLogin();
    setToken(token);

    setinCaricamento(false);

    if (window.location.pathname === "/login") {
      if (!passwordErrata)
        //addToast("Nome utente o password non valida", { appearance: "error", autoDismiss: true, placement: 'bottom-left' });
        //else
        history.push(process.env.PUBLIC_URL + global.urlRedirectAfterLogin);
    }

    //window.location.reload();
  };

  const { addToast } = useToasts();
  var strings = require("../../translations/italian.json");
  var informazioni = global.informazioni;

  return (
    <Fragment>
      <MetaTags>
        <title>
          {strings.login_register} | {informazioni.titleSite}
        </title>
        <meta
          name="description"
          content={strings.login_register + " " + strings.siteContent}
        />
      </MetaTags>

      <LayoutOne headerTop="invisible">
        {/* breadcrumb */}
        <Breadcrumb />

        <div className="login-register-area pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="d-flex justify-content-center col-lg-7 col-md-12 mx-auto">
                <div className="login-register-wrapper">
                  <Tab.Container defaultActiveKey="login" activeKey={tab}>
                    <Nav
                      variant="pills"
                      className="login-register-tab-list"
                      activeKey={tab}
                    >
                      <Nav.Item>
                        <Nav.Link
                          eventKey="login"
                          onSelect={() => setTab("login")}
                        >
                          <h4>Login</h4>
                        </Nav.Link>
                      </Nav.Item>
                      {global.aziendaID == 1 ? (
                        <Nav.Item>
                          <Nav.Link
                            eventKey="register"
                            onSelect={() => setTab("register")}
                          >
                            <h4>Registrati</h4>
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="login">
                        <div className="login-form-container">
                          <div className="login-register-form">
                            <form>
                              <p>
                                Per effettuare l'accesso inserire il codice
                                cliente riportato in fattura sia nel nome utente
                                che nella password
                              </p>
                              <input
                                type="text"
                                name="user-name"
                                placeholder="Nome Utente"
                                required
                                defaultValue={username}
                                onChange={(e) => setUserName(e.target.value)}
                                style={{ marginBottom: "20px" }}
                              />
                              <input
                                type="password"
                                name="user-password"
                                placeholder="Password"
                                required
                                defaultValue={password}
                                onChange={(e) => setPassword(e.target.value)}
                              />
                              <div className="button-box">
                                <div className="login-toggle-btn">
                                  <input type="checkbox" />
                                  <label className="ml-10">
                                    Ricorda la Password
                                  </label>
                                  <Link
                                    to={
                                      process.env.PUBLIC_URL +
                                      "/forgot-password"
                                    }
                                  >
                                    Password dimenticata?
                                  </Link>
                                </div>

                                <div className="login-toggle-btn">
                                  {!inCaricamento && (
                                    <button onClick={handleSubmit} id="login">
                                      <span>Accedi</span>
                                    </button>
                                  )}
                                  {inCaricamento && (
                                    <Article key={"bars"}>
                                      <ReactLoading
                                        type={"bars"}
                                        color="black"
                                      />
                                      <Prop>{"Bars"}</Prop>
                                    </Article>
                                  )}
                                </div>
                                {sessioneScaduta &&
                                  window.localStorage.getItem("lastLogin") && (
                                    <div
                                      style={{
                                        backgroundColor: "red",
                                        color: "white",
                                        textAlign: "center",
                                        borderRadius: "10px",
                                      }}
                                    >
                                      La sessione è scaduta, per favore effettua
                                      di nuovo il login!
                                    </div>
                                  )}
                              </div>
                            </form>
                          </div>
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="register">
                        <div className="login-form-container">
                          <div className="login-register-form">
                            <form>
                              <div className="myaccount-info-wrapper">
                                {/*Qua Corretto */}
                                <div className="row">
                                  <img
                                    style={{
                                      height: 150,
                                      width: 150,
                                      padding: 10,
                                      display: "none",
                                    }}
                                    src="https://www.edilpitture-schiavato.com/stili/vbuilder/img/azienda3.png"
                                  ></img>
                                  <div className="container">
                                    <label style={{ color: "#2e98f0" }}>
                                      Ragione Sociale:
                                    </label>
                                    <input
                                      type="text"
                                      name="user-name"
                                      placeholder="Ragione sociale"
                                      nomeField="RagSoc"
                                      onChange={(e) =>
                                        setUserName(e.target.value)
                                      }
                                    />
                                  </div>

                                  <h5 style={{ color: "#2e98f0" }}>
                                    DATI DI FATTURAZIONE - Informazioni
                                    Aziendali
                                  </h5>

                                  <div className="col-lg-6 col-md-6">
                                    <label>Codice Fiscale</label>
                                    <input
                                      placeholder="Codice Fiscale"
                                      nome="CodFis"
                                      nomeField="CodFis"
                                      type="text"
                                    />
                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <label>Partita IVA</label>
                                    <input
                                      nome="ParIVA"
                                      nomeField="ParIva"
                                      placeholder="Partita IVA"
                                      type="text"
                                    />
                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <label>Cod.Destinatario</label>
                                    <input
                                      id="CodDes"
                                      nome="CodDest"
                                      nomeField="CodDes"
                                      placeholder="Codice Destinatario"
                                      type="text"
                                    />
                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <label>PEC</label>
                                    <input
                                      id="EMailPec"
                                      nome="EMailPec"
                                      nomeField="EMailPec"
                                      placeholder="EMail - PEC"
                                      pattern="/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/"
                                      title="Invalid email address"
                                      type="email"
                                    />
                                  </div>
                                  <hr style={{ marginTop: "30px" }}></hr>
                                  <h5 style={{ color: "#2e98f0" }}>
                                    SEDE LEGALE - Indirizzo di fatturazione
                                  </h5>

                                  <div className="col-lg-12 col-md-12">
                                    <label>Indirizzo</label>
                                    <input
                                      id="IndSedLeg"
                                      nome="Indirizzo"
                                      nomeField="IndSedLeg"
                                      placeholder="Indirizzo"
                                      type="text"
                                    />
                                  </div>

                                  <div className="col-lg-12">
                                    <label>Località</label>
                                    <Autocomplete
                                      className="data"
                                      id="country-select-demo-legale"
                                      options={localita}
                                      autoHighlight
                                      onChange={(event, value) =>
                                        setSede(value)
                                      }
                                      getOptionLabel={(option) => option.Loc}
                                      style={{
                                        border: "none",
                                        marginTop: "10px",
                                      }}
                                      sx={{
                                        border: "1px solid green",
                                        borderRadius: 1,
                                      }}
                                      renderOption={(option) => (
                                        <React.Fragment>
                                          {option.Loc +
                                            " (" +
                                            option.Pro +
                                            ") - " +
                                            option.CAP}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          placeholder="Località"
                                          error={error}
                                          inputProps={{
                                            ...params.inputProps,
                                            autoComplete: "new-password", // disable autocomplete and autofill
                                            style: { border: "none" },
                                          }}
                                        />
                                      )}
                                    />
                                    <input
                                      type="text"
                                      defaultValue={sede?.Loc}
                                      id="loc"
                                      disabled
                                      style={{ display: "none" }}
                                      className="data"
                                    />
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <label>CAP</label>
                                    <input
                                      nome="Cap"
                                      nomeField="Cap"
                                      placeholder="C.A.P."
                                      type="text"
                                      value={sede ? sede.CAP : ""}
                                      disabled
                                    />
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <label>Provincia</label>
                                    <input
                                      nome="SedLegPro"
                                      nomeField="Pro"
                                      placeholder="Provincia"
                                      type="text"
                                      maxLength="3"
                                      value={sede ? sede.Pro : ""}
                                      disabled
                                    />
                                  </div>
                                  <hr style={{ marginTop: "30px" }}></hr>
                                  <h5 style={{ color: "#2e98f0" }}>
                                    SEDE OPERATIVA - Indirizzo di spedizione{" "}
                                    <br /> ⚠️⚠️⚠️se identico all'indirizzo di
                                    fatturazione,⚠️⚠️⚠️ <br />
                                    ⚠️⚠️⚠️&nbsp;&nbsp;&nbsp;non compilare i
                                    campi sottostanti&nbsp;&nbsp;&nbsp;⚠️⚠️⚠️
                                  </h5>

                                  <div className="col-lg-12 col-md-12">
                                    <label>Indirizzo</label>
                                    <input
                                      nome="Indirizzo"
                                      nomeField="IndSedOpe"
                                      placeholder="Indirizzo"
                                      type="text"
                                    />
                                  </div>

                                  <div className="col-lg-12">
                                    <label>Località</label>
                                    <Autocomplete
                                      className="data"
                                      id="country-select-demo"
                                      options={localita}
                                      autoHighlight
                                      onChange={(event, value) =>
                                        setSedeOperativa(value)
                                      }
                                      getOptionLabel={(option) => option.Loc}
                                      style={{
                                        border: "none",
                                        marginTop: "10px",
                                      }}
                                      sx={{
                                        border: "1px solid green",
                                        borderRadius: 1,
                                      }}
                                      renderOption={(option) => (
                                        <React.Fragment>
                                          {option.Loc +
                                            " (" +
                                            option.Pro +
                                            ") - " +
                                            option.CAP}
                                        </React.Fragment>
                                      )}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          variant="outlined"
                                          placeholder="Località"
                                          inputProps={{
                                            ...params.inputProps,
                                            autoComplete: "new-password", // disable autocomplete and autofill
                                            style: { border: "none" },
                                          }}
                                        />
                                      )}
                                    />
                                    <input
                                      type="text"
                                      defaultValue={sede?.Loc}
                                      id="loc"
                                      disabled
                                      style={{ display: "none" }}
                                      className="data"
                                    />
                                  </div>
                                  {/*<input 
                                    nome = "SedLegLocalita"
                                    nomeField = "Loc"
                                    placeholder="Località"
                                    type="text"
                              />*/}
                                  <div className="col-lg-3 col-md-3">
                                    <label>CAP</label>
                                    <input
                                      nome="Cap"
                                      nomeField="Cap"
                                      placeholder="C.A.P."
                                      type="text"
                                      value={
                                        sedeOperativa ? sedeOperativa.CAP : ""
                                      }
                                      disabled
                                    />
                                  </div>
                                  <div className="col-lg-3 col-md-3">
                                    <label>Provincia</label>
                                    <input
                                      nome="SedLegPro"
                                      nomeField="Pro"
                                      placeholder="Provincia"
                                      type="text"
                                      maxLength="3"
                                      value={
                                        sedeOperativa ? sedeOperativa.Pro : ""
                                      }
                                      disabled
                                    />
                                  </div>
                                  <div className="col-lg-12 col-md-6 row">
                                    <div className="account-info-wrapper">
                                      <hr style={{ marginTop: "30px" }}></hr>
                                      <h5 style={{ color: "#2e98f0" }}>
                                        LE MIE INFORMAZIONI - Informazioni
                                        Personali
                                      </h5>
                                    </div>
                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <label>Nome</label>
                                    <input
                                      nome="Nom"
                                      nomeField="Nom"
                                      placeholder="Nome"
                                      type="text"
                                    />
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <label>Cognome</label>
                                    <input
                                      placeholder="Cognome"
                                      nome="Cog"
                                      nomeField="Cog"
                                      type="text"
                                    />
                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <label>Email</label>
                                    <input
                                      nome="Mail"
                                      nomeField="EMail"
                                      placeholder="Indirizzo E-Mail"
                                      required={true}
                                      type="email"
                                    />
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <label>Sito WEB</label>
                                    <input
                                      nome="Web"
                                      nomeField="SitWeb"
                                      placeholder="Sito WEB"
                                      type="url"
                                    />
                                  </div>

                                  <div className="col-lg-6 col-md-6">
                                    <label>Numero Telefonico</label>
                                    <input
                                      placeholder="Numero Telefonico"
                                      nome="Tel"
                                      nomeField="Tel"
                                      required={true}
                                      type="text"
                                    />
                                  </div>
                                  <div className="col-lg-6 col-md-6">
                                    <label>Cellulare</label>
                                    <input
                                      placeholder="Numero di Cellulare"
                                      nome="Cel"
                                      nomeField="Cel"
                                      type="text"
                                    />
                                  </div>
                                </div>

                                <div className="button-box">
                                  <div className="login-toggle-btn">
                                    {!inCaricamento && (
                                      <button onClick={handleRegistrati}>
                                        <span>Registrati</span>
                                      </button>
                                    )}
                                    {inCaricamento && (
                                      <Article key={"bars"}>
                                        <ReactLoading
                                          type={"bars"}
                                          color="black"
                                        />
                                        <Prop>{"Bars"}</Prop>
                                      </Article>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutOne>
    </Fragment>
  );
};

LoginRegister.propTypes = {
  location: PropTypes.object,
  setToken: PropTypes.func.isRequired,
  userData: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    products: state.productData.products,
    userData: state.userData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveUser: (user, addToast) => {
      dispatch(saveUser(user, addToast));
    },
    saveProducts: (products, addToast) => {
      dispatch(saveProducts(products, addToast));
    },
  };
};

//export default LoginRegister;
export default connect(mapStateToProps, mapDispatchToProps)(LoginRegister);
